import PropTypes from "prop-types"
import React from "react"
import { Card, CardBody, Col } from "reactstrap"
import Loader from "react-loader-spinner"
import Tooltip from "../../components/Common/tooltip"

const MiniCards = props => {
  const { title, text, texts, iconClass, loading, tooltip, id, columns } = props
  return (
    <React.Fragment>
      <Col md={columns ? columns : "4"}>
        <Card className="mini-stats-wid">
          <CardBody>
            <div className="d-flex">
              <div className="flex-grow-1">
                <p className="text-muted fw-medium">{title}
                  <Tooltip id={id} tooltip={tooltip}>
                  </Tooltip>
                </p>
                {loading ? (
                  <div className="loader-container position-absolute">
                    <Loader
                      type="ThreeDots"
                      color="#556EE6"
                      height={80}
                      width={80}
                    />
                  </div>
                ) : (
                  Array.isArray(texts) ? (
                    texts.map((item, index) => (
                      <div key={item.label + '_wrap_' + index} className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center mb-2">
                        <span>{item.label}:</span>
                        <div className="d-flex align-items-center align-self-end align-self-md-auto">
                          <h5 className="mb-0 me-2">{item.value}</h5>
                          <span className={"badge badge-soft-" + item.color + " font-size-12"}>
                            { " " }
                            { item.badgeValue }{ " " }
                          </span>{ " " }
                          <Tooltip id={'mini-card_tooltip_' + index} tooltip={ item.tooltip }>
                          </Tooltip>
                        </div>
                      </div>
                    ))
                  ) : (
                    <h4 className="mb-0">{text}</h4>
                  )
                )}
              </div>
              {iconClass && <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
                <span className="avatar-title">
                  <i className={"bx " + iconClass + " font-size-24"} />
                </span>
              </div>}
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  )
}

MiniCards.propTypes = {
  iconClass: PropTypes.string,
  text: PropTypes.string,
  texts: PropTypes.array,
  title: PropTypes.string,
  loading: PropTypes.bool,
  tooltip: PropTypes.string,
  columns: PropTypes.number,
  id: PropTypes.string
}

export default MiniCards
